import { render } from "./StepTipologia.vue?vue&type=template&id=55547fa0&scoped=true"
import script from "./StepTipologia.vue?vue&type=script&lang=js"
export * from "./StepTipologia.vue?vue&type=script&lang=js"

import "./StepTipologia.vue?vue&type=style&index=0&id=55547fa0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55547fa0"]])

export default __exports__